
import { css } from '@emotion/react';
import {Colors} from '@vc-workspace/utils-colors';
import {DIMENSIONS} from '@vc-workspace/utils-dimens';

export const containerStyles = css({
  width: '100%',
  position: 'sticky',
  bottom: '0px',
  left: '0px',
  background: Colors.white,
  padding: DIMENSIONS.px_20,
  display: "flex",
  flexFlow: 'row wrap',
  justifyContent: 'space-around',
  columnGap: DIMENSIONS.px_40,
  boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.1)'
})

export const usePositionAbsolute = css({
  position: 'absolute'
})

export const usePositionFixed = css({
  position: 'fixed',
  zIndex: 100
})